import {
  CLIENT_CLIENT_REFERRAL_LIST,
  CLIENT_CLIENT_REFERRAL_SPOC_LIST,
  CLIENT_CLIENT_REFERRAL_REJECT_REASONS,
  CLIENT_CLIENT_REFERRAL_STATUS_HISTORY,
} from './type';

const emptySpocOptions = { regionOptions: [], spocOptionsByRegion: {} };

const initialState = {
  referralList: { referrals: [], count: 0, page: 1, limit: 20, incentiveAmounts: null },
  spocOptions: emptySpocOptions,
  rejectReasons: [],
  statusHistory: [],
};

export default function clientClientReferralReducer(state = initialState, action) {
  switch (action.type) {
    case CLIENT_CLIENT_REFERRAL_LIST:
      return { ...state, referralList: action.payload };
    case CLIENT_CLIENT_REFERRAL_SPOC_LIST:
      return { ...state, spocOptions: action.payload };
    case CLIENT_CLIENT_REFERRAL_REJECT_REASONS:
      return { ...state, rejectReasons: action.payload };
    case CLIENT_CLIENT_REFERRAL_STATUS_HISTORY:
      return { ...state, statusHistory: action.payload };
    default:
      return state;
  }
}
